import { nativeBackPath } from './nativeBackForms';

export type MobileScreen =
  | { kind: 'brand'; root?: 'home' }
  | { kind: 'root'; root: 'discover' | 'chats' | 'friends' | 'settings' }
  | { kind: 'settings'; section: string }
  | { kind: 'detail'; entity: 'post' | 'player' | 'me' | 'notifications'; id?: string }
  | { kind: 'task'; editing: boolean; id?: string };

export const mobileScreen = (pathname: string): MobileScreen => {
  const path = nativeBackPath(pathname);
  if (path === '/dashboard') return { kind: 'brand', root: 'home' };
  if (path === '/dashboard/notifications') return { kind: 'detail', entity: 'notifications' };
  if (path === '/dashboard/discover') return { kind: 'root', root: 'discover' };
  if (path === '/dashboard/chats') return { kind: 'root', root: 'chats' };
  if (path === '/dashboard/friends') return { kind: 'root', root: 'friends' };
  if (path === '/dashboard/settings') return { kind: 'root', root: 'settings' };
  if (path.startsWith('/dashboard/settings/'))
    return { kind: 'settings', section: path.split('/').at(-1)! };
  if (path === '/dashboard/discover/create') return { kind: 'task', editing: false };
  const edit = path.match(/^\/dashboard\/discover\/posts\/([^/]+)\/edit$/);
  if (edit) return { kind: 'task', editing: true, id: edit[1] };
  const post = path.match(/^\/posts\/([^/]+)$/);
  if (post) return { kind: 'detail', entity: 'post', id: post[1] };
  const player = path.match(/^\/players\/([^/]+)$/);
  if (player) {
    let id = player[1];
    try {
      id = decodeURIComponent(id);
    } catch {
      /* Keep a malformed deep link navigable. */
    }
    return { kind: 'detail', entity: 'player', id };
  }
  if (path === '/dashboard/profile') return { kind: 'detail', entity: 'me' };
  return { kind: 'brand' };
};

/** Only a previous entry observed in this router session may be used as an origin. */
export const canReturnToOrigin = (previous: string | undefined, current: string): boolean =>
  !!previous &&
  previous !== current &&
  previous.startsWith('/') &&
  !previous.startsWith('//') &&
  !/^\/(?:ru\/|en\/)?(?:sign-in|sign-up|forgot-password|reset-password|confirm-registration)(?:\/|[?#]|$)/.test(
    previous
  );
